// Brand registry — single source of truth for slug/name/aliases/logo,
// reusable across PopularBrands, brand search normalization, filters, and
// future brand pages (2026-09). Slugs/aliases mirror
// server/utils/brandSearch.js's KNOWN_BRANDS exactly; keep both in sync if
// either changes.
//
// Logos live in src/components/Home/img/brands/ under their REAL, as-given
// filenames (mixed SVG/PNG/JPG, not renamed to match slug.ext — see that
// folder's README.md) and are wired in via an explicit `logoFile` per brand
// below, resolved through require.context so webpack still bundles
// everything in that folder automatically. A brand whose `logoFile` isn't
// found in the folder gets `logo: null`, and PopularBrands.js falls back to
// a text/wordmark tile for it — never a broken image.
const logoContext = require.context(
  '../components/Home/img/brands',
  false,
  /\.(svg|png|jpe?g|webp)$/
);

const logoByFilename = {};
logoContext.keys().forEach((key) => {
  const filename = key.replace(/^\.\//, '');
  logoByFilename[filename] = logoContext(key);
});

const BRAND_DEFS = [
  { slug: 'zara', name: 'Zara', aliases: ['Zara'], logoFile: 'Zara_Logo.svg' },
  { slug: 'h-and-m', name: 'H&M', aliases: ['H&M', 'HM'], logoFile: 'h-m-logo.svg' },
  { slug: 'mango', name: 'Mango', aliases: ['Mango'], logoFile: 'Mango-logo.png' },
  { slug: 'reserved', name: 'Reserved', aliases: ['Reserved'], logoFile: 'reserved-logo-vector.png' },
  { slug: 'nike', name: 'Nike', aliases: ['Nike', 'Найк'], logoFile: 'nike.svg' },
  { slug: 'next', name: 'Next', aliases: ['Next'], logoFile: 'next.png' },
  { slug: 'bershka', name: 'Bershka', aliases: ['Bershka'], logoFile: 'bershka-logo-png_seeklogo-669532.png' },
  { slug: 'shein', name: 'Shein', aliases: ['Shein'], logoFile: 'shein.jpg' },
  { slug: 'adidas', name: 'Adidas', aliases: ['Adidas', 'Адідас'], logoFile: 'Adidas-Logo.png' },
];

export const BRANDS = BRAND_DEFS.map((b) => ({ ...b, logo: logoByFilename[b.logoFile] || null }));

export function getBrandBySlug(slug) {
  return BRANDS.find((b) => b.slug === slug) || null;
}
